goog.provide("shadow.js.shim.module$src$svg$person$person_circle_svg");
goog.provide("module$shadow_js_shim_module$src$svg$person$person_circle_svg");
shadow.js.shim.module$src$svg$person$person_circle_svg = shadow.js.nativeProvides["src/svg/person/person-circle.svg"] = shadow$bridge("src/svg/person/person-circle.svg");
module$shadow_js_shim_module$src$svg$person$person_circle_svg.default = shadow.js.shim.module$src$svg$person$person_circle_svg;
